import React, { Fragment, useState, useEffect } from 'react';
import CustomTable from '@jumbo/components/CustomTable';
import PageLoader from '@jumbo/components/custom/Spinner/pageLoader';
import { validacionPermit } from '../../../../../services/service.user';
import { CustomToast } from '@jumbo/components/custom/Toast';
import Spinner from '@jumbo/components/custom/Spinner';
import {
  tableHeadCellsCorreosNotificacion,
  validaciones,
  correosNotificacionActions,
} from '../../AppComponentsNUtils/SeguimientoReclamosUtils';

import CreateUserCorreosNotificacion from '../Components/CreateUser';
import DeleteUserDialog from '../Components/DeleteUser';
import { getRegiones } from 'services/api';

const mockupDataCorreos = [
  {
    user: 'ramon test',
    cargo: 'tester',
    region: 'primera',
    email: 'asd@asd.cl',
    id_region: '1',
    mediacion: true,
    controversia: true,
    reclamo: false,
    derivacion: false,
  },
  {
    user: 'joahn test',
    cargo: 'tester',
    region: 'segunda',
    email: 'asd@asd.cl',
    id_region: '2',
    mediacion: false,
    controversia: false,
    reclamo: false,
    derivacion: true,
  },
  {
    user: 'stephens test',
    cargo: 'tester',
    region: 'tercera',
    email: 'asd@asd.cl',
    id_region: '3',
    mediacion: true,
    controversia: false,
    reclamo: true,
    derivacion: false,
  },
];

const TablaCorreosDeNotificacion = () => {
  const [primeraCarga, setPrimeraCarga] = useState(false);
  const [correosList, setCorreosList] = useState([]);
 // const [showVerUsuario, setShowVerUsuario] = useState(false);
//  const [usuarioVer, setUsuarioVer] = useState(null); test push
  const [userDelete, setUserDelete] = useState(null);
  const [showDeleteUser, setShowDeleteUser] = useState(false);
  const [showCreateUser, setShowCreateUser] = useState(false);
  const [userEdit, setUserEdit] = useState(null);
  const [showUserEdit, setShowUserEdit] = useState(false);
  const [spinner, setSpinner] = useState(false);
  const [reload, setReload] = useState(false);

  const [regionesList, setRegionesList] = useState([]);

  const loadData = () => {
    setSpinner(true);
    getRegiones()
      .then(res => {
        setRegionesList(res.data);
      })
      .catch(err => {
        console.error(err);
      })
      .finally(f => {
        setSpinner(false);
      });

    setPrimeraCarga(true);
    setCorreosList(mockupDataCorreos);
  };

  useEffect(() => {
    loadData();
  }, [reload]);

  const handleAction = (menu, item) => {
    if (menu.action === 'modificar') {
      setUserEdit(item);
      setShowUserEdit(true);
    } else if (menu.action === 'eliminar') {
      setUserDelete(item);
      setShowDeleteUser(true);
    }
  };

  const openModal = fila => {
   // setUsuarioVer(fila);
   // setShowVerUsuario(true);
   setReload(!reload)
  };

  const createUSer = () => {
    setShowCreateUser(true);
  };

  const createUserClose = () => {
    setShowCreateUser(false);
  };

  const deleteUserClose = () => {
    setShowDeleteUser(false);
  };

  const editUserClose = () => {
    setShowUserEdit(false);
  };

  const submitCreateUser = () => {
    console.log('creating');
  };

  const submitEditUser = () => {
    console.log('editing');
  };

  const submitDeleteUser = () => {
    console.log('deleting');
  };

  return (
    validacionPermit('search_reclaim_if') && (
      <Fragment>
        <Spinner show={spinner} />
        <CustomToast />
        <CreateUserCorreosNotificacion
          regionesList={regionesList}
          openDialog={showCreateUser}
          onCloseDialog={createUserClose}
          user={null}
          onSubmitClick={submitCreateUser}
        />

        <CreateUserCorreosNotificacion
          regionesList={regionesList}
          openDialog={showUserEdit}
          onCloseDialog={editUserClose}
          user={userEdit}
          onSubmitClick={submitEditUser}
        />

        <DeleteUserDialog
          openDialog={showDeleteUser}
          close={deleteUserClose}
          submit={submitDeleteUser}
          userDelete={userDelete}
        />

        {primeraCarga ? (
          correosList.length === 0 ? (
            <h1>No tiene correos</h1>
          ) : (
            <CustomTable
              headCells={tableHeadCellsCorreosNotificacion}
              rows={correosList}
              title={'Usuarios'}
              validation={validaciones}
              search={true}
              actions={correosNotificacionActions}
              handleAction={handleAction}
              openModal={openModal}
              addText={'Crear'}
              add={createUSer}
            />
          )
        ) : (
          <PageLoader />
        )}
      </Fragment>
    )
  );
};

export default TablaCorreosDeNotificacion;
